import { styled } from '@mui/material/styles';
import { Image, Stack } from 'core/common/ui/ui-kit';

export const CardWrapperStyled = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.secondary};
`;

export const AvatarStyled = styled(Image)`
  border-radius: 50%;
`;

export const AvatarFallbackStyled = styled(Stack)`
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.glow.avatar};
`;
